import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { restoreStringifiedArray } from '../../ParseHelper';
import { ArrayHelper } from 'Utility/ArrayHelper';

type PlayerStateKey = 'FBEvents';
type PlayerDataKeys = 'FBEvents';
export default class Tracking implements PlayerProperty<PlayerStateKey, PlayerDataKeys> {
    public isChanged(playerStateData: IPlayerState, playerEndpointData: IPlayerData): boolean {
        return playerEndpointData.FBEvents !== JSON.stringify(playerStateData.FBEvents);
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        return restoreStringifiedArray(playerEndpointData.FBEvents, []).filter(ArrayHelper.filterOnce);
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        return {
            FBEvents: JSON.stringify(playerStateData.FBEvents),
        };
    }
}
